<template>
    <el-select :value="value" class="select" filterable clearable remote allow-create :remote-method="searchserviceTickets" :placeholder="$t('shared.pleaseSelectTicket')" :loading="loading" @change="selectCustomer($event)">
        <el-option v-for="item in serviceTickets" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
</template>

<script>
    import api from "./api";
    import { EventBus } from "@/app/event-bus.js";
    export default {
        name: "service-ticket-selector",
        props: ["value", "customerName"],
        watch: {
            customerName(newValue) {
                console.info(newValue)
                if (newValue) {
                    this.searchserviceTickets(newValue);
                }
            }
        },
        data() {
            return {
                loading: false,
                serviceTickets: []
            };
        },
        methods: {
            searchserviceTickets(term) {
                var self = this;
                self.loading = true;
                api.getServiceTicket(term).then(function (response) {
                    self.loading = false;
                    self.serviceTickets = response.data;
                });
            },
            selectCustomer(event) {
            
                this.$emit("input", event);
            },
            searchserviceTicketsById(id, callback) {
                var self = this;
                self.loading = true;
                api.getserviceTicketsById(id).then(function (response) {
                    self.loading = false;
                    self.serviceTickets = response.data;

                    if (callback) {
                        callback();
                    }
                });
            },
            getserviceTickets() {
                return this.serviceTickets;
            }
        },
        created() {
            this.searchserviceTickets("");
        }
    };
</script>

<style scoped>
    .select {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/shared/components/serviceticketselector/ServiceTicketSelector.vue